// @flow
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { ArticleDetail, ArticleSide, SidePillSavings, Video, ArticleCTA } from '../../../components';

type Props = {
  staticContext?: Object,
  location: Object,
  history: Object,
  toggleModal: Function
};

export const Invertir = ({ location, history, toggleModal }: Props) => {
  const redirectTo = (url: string) => {
    history.push(url);
  };

  return (
    <ArticleDetail
      location={location}
      title="Cómo puede ayudarte un asesor a invertir tu dinero."
      redirectTo={redirectTo}
      toggleModal={toggleModal}
    >
      <Video
        id="B4TowIvPha4"
        src="https://www.youtube.com/embed/B4TowIvPha4?hd=1&showinfo=0&controls=0&rel=0&enablejsapi=1"
      />
      <Paragraph>
        ¿Invierto en fondos de inversión o directamente en bolsa? ¿Cuántas inversiones distintas debo tener en mi
        cartera? ¿Y qué productos concreto selecciono? ¿Cómo me aseguro de que no estoy asumiendo un riesgo excesivo en
        un tipo de compañías o en un país? ¿Cada cuanto debo hacer cambios? ¿Qué hacer con mis inversiones ante una
        crisis inesperada en los mercados?
      </Paragraph>
      <Paragraph>
        Nadie dijo que fuera fácil buscar rentabilidad para ese dinero que tanto nos cuesta ahorrar y para el que
        queremos la mayor estabilidad. Y mucho menos, desde que los depósitos dejaron de ser el destino natural para el
        ahorro de millones de ciudadanos, por la desaparición casi total de los intereses.
      </Paragraph>
      <ArticleSide position="right">
        <SidePillSavings />
      </ArticleSide>
      <Paragraph>
        Con unos mercados cada vez más complejos, supone todo un reto para las familias obtener rentabilidad para su
        dinero, al mismo tiempo que resulta imprescindible si no queremos que la inflación se acabe comiendo nuestro
        poder adquisitivo.
      </Paragraph>
      <Paragraph>
        Y aquí es donde cobra especial relevancia el papel del asesor financiero. Este experto nos ayudará a establecer
        nuestros objetivos, ver el dinero que necesitamos conseguir para permitírnoslos y, por lo tanto, el nivel de
        inversión y la rentabilidad mínima imprescindible para lograrlos.
      </Paragraph>
      <Paragraph>
        Todo ello se debería concretar en un plan, seguido de una propuesta de inversión, con una estrategia específica
        y productos financieros concretos, que él mismo seleccionará para nosotros, entre todas las opciones que ofrecen
        los mercados. Así, delegaremos en él la selección de inversiones y podremos pedirle responsabilidades.
      </Paragraph>
      <Paragraph>
        Aquí, resulta fundamental contar con un asesor que esté siempre alineado con nosotros. Es decir, que sus
        ingresos dependan de cómo nos vaya a nosotros y no de los productos que nos recomienden, como tantas veces ha
        sucedido en las sucursales bancarias.
      </Paragraph>
      <ArticleCTA toggleModal={toggleModal} />
      <Paragraph>
        El buen asesor, además, estará siempre pendiente de nosotros y de nuestros objetivos. Además de hacer el
        seguimiento diario de nuestro plan de inversión y nuestra cartera, nos recomendará cambios cuando las
        circunstancias del mercado cambien o cuando descubra mejores productos para sacar más partido a nuestro dinero.
      </Paragraph>
      <Paragraph>
        Eso sí, casi tan importante como llevar un buen control de nuestros números, el asesor tiene una una misión
        fundamental: ayudarnos a evitar los errores más habituales al gestionar nuestro dinero. La mayoría, derivados de
        la dificultad para controlar nuestras emociones, que nos impulsan a entrar en bolsa cuando la burbuja está a
        punto de explotar o salir en el peor momento, cuando está a punto de recuperar.
      </Paragraph>
      <Paragraph>
        También debemos exigirle a nuestro asesor optimizar la rentabilidad de nuestros ahorros, eligiendo siempre las
        mejores opciones fiscales para nuestro dinero. Hay una ventaja adicional de buscar un asesor para nuestros
        ahorros: evitar que la pereza y el desconocimiento sobre las finanzas implique que vayamos retrasando el momento
        de empezar a invertir, que tanto dinero nos puede acabar costando a largo plazo.
      </Paragraph>
    </ArticleDetail>
  );
};
